import { useEffect, useState } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { type PageLayoutStore } from 'shared/layout'
import { type IResponseRecurringBroadcastById } from 'entities/Broadcast/api/types'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BroadcastDetailRecurringStore } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring/store/broadcastDetailRecurringStore'
import { BroadcastDetailRecurringContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring/context/context'
import { Content } from './Content'

type IBroadcastDetailOneTimeProps = {
  broadcastResponse: IResponseRecurringBroadcastById
  pageLayoutStore: PageLayoutStore
}

export const BroadcastDetailRecurring = ({
  broadcastResponse,
  pageLayoutStore,
}: IBroadcastDetailOneTimeProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(
    () => new BroadcastDetailRecurringStore(broadcastResponse, pageLayoutStore, entities)
  )
  useEffect(() => {
    uiStore.setCustomPathLabel(
      `/${BroadcastsRoutes.root}/${BroadcastsRoutes.view}/${broadcastResponse.id}`,
      broadcastResponse.name
    )
  }, [])
  useEffect(store.init, [])
  return (
    <BroadcastDetailRecurringContext.Provider value={store}>
      <Content />
    </BroadcastDetailRecurringContext.Provider>
  )
}
